import { render, staticRenderFns } from "./Izmeni.vue?vue&type=template&id=dea9ce34&"
import script from "./Izmeni.vue?vue&type=script&lang=js&"
export * from "./Izmeni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports